<template>
  <div>
    <Modal v-model="show"  @on-visible-change="visibleChange">
      <h3 slot="header" style="padding-left: 25px">密码锁详情</h3>
      <div class="mb25">
        <span>状态: </span>
        <span :class="[{'red':info.onoffLine==2},{'green':info.onoffLine==1}]">{{onoffLineMap[info.onoffLine+'']}}</span>
      </div>
      <div class="mb25">
        <span>电量: </span>
        <span>{{info.power==-1?'未知':info.power+'%'}}</span>
      </div>
      <div class="mb25" style="text-align: center">
        <Button  type="primary" @click="getDynamicPwd">查看动态密码</Button>
      </div>
      <div class="mb25" v-if="dynamicInfo.pwd">
        <span>密码明文: </span>
        <span class="red">{{dynamicInfo.pwd}}</span>
      </div>
      <div class="mb25" v-if="dynamicInfo.endTime">
        <span>失效时间: </span>
        <span class="red">{{dynamicInfo.endTime}}</span>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {getDynamicPwd} from 'api/getPassword'

  export default {
    name: "LockinfoModal",
    props: {
      n: {
        type: Number,
        default: 0
      },
      info: {
        type: Object,
        default: null
      },

    },
    data() {
      return {
        show: false,
        dynamicInfo: {
          endTime: '',
          pwd: ''
        },
        onoffLineMap:{
          '-1':'未知',
          '1':'在线',
          '2':'离线'
        }
      }
    },
    methods: {
      visibleChange(state){
        if(state==false){
          this.$emit('closeLockInfo')
          this.dynamicInfo.endTime=''
          this.dynamicInfo.pwd=''
        }
      },
      getDynamicPwd() {
        let params = {
          roomId: this.info.roomId
        }
        getDynamicPwd(params).then(res => {
          this.dynamicInfo.endTime = res.data.endTime
          this.dynamicInfo.pwd = res.data.pwd
        })
      }
    },
    watch: {
      n() {
        this.show = true
      }
    }
  }
</script>
<style scoped>
  .search-button {
    padding: 8px 22px;
    margin: 0 auto;
  }

  .mb25 {
    margin-bottom: 25px;
  }
  .red{
    color: red;
    font-weight: bold;
  }
  .green{
    color: rgb(94,166,75);
    font-weight: bold;
  }

</style>
